import { render, staticRenderFns } from "./restaurants.vue?vue&type=template&id=493c8184&lang=html&"
import script from "./restaurants.vue?vue&type=script&lang=js&"
export * from "./restaurants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports